<nav class="sidebar" [class.collapsed]="collapsed">
  @if (collapsed) {
    <div class="logo-container">
      <a routerLink="/" class="logo-link">
        <img src="assets/brand/favicon.webp" alt="Logo" class="logo" />
      </a>
    </div>
  }
  @if (!collapsed || mobileSidebarOpen) {
    <div class="header-left">
      <img class="ff-logo" src="assets/images/svg/fagforbundet-logo-rgb.webp" alt="Logo" />
    </div>
  }

  <ul class="menu">
    @if (collapsed && !mobileSidebarOpen) {
      @for (item of collapsedItems; track item.text) {
        <li>
          @if (item.elink) {
            <a class="menu-item" [href]="item.elink" target="_blank" rel="noopener">
              @if (item.icon) {
                <mat-icon [matTooltip]="item.text" matTooltipPosition="right">{{ item.icon }}</mat-icon>
              }
              @if (item.cssClass) {
                <span class="custom-icon" [ngClass]="item.cssClass" [matTooltip]="item.text" matTooltipPosition="right"></span>
              }
            </a>
          } @else {
            <a
              class="menu-item"
              [routerLink]="item.link"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              @if (item.icon) {
                <mat-icon [matTooltip]="item.text" matTooltipPosition="right">{{ item.icon }}</mat-icon>
              }
              @if (item.cssClass) {
                <span class="custom-icon" [ngClass]="item.cssClass" [matTooltip]="item.text" matTooltipPosition="right"></span>
              }
            </a>
          }
        </li>
      }
    } @else {
      @for (item of items; track item.text) {
        @if (item.heading && item.subItems?.length) {
          <li>
            <button class="menu-section" [class.expanded]="item.subMenuOpen" type="button" (click)="toggleSection(item, $event)">
              <span class="menu-section-label">{{ item.text }}</span>
              <mat-icon class="menu-section-icon" [class.open]="item.subMenuOpen">chevron_right</mat-icon>
            </button>

            @if (item.subMenuOpen) {
              <ul class="submenu">
                @for (subItem of item.subItems; track subItem.text) {
                  <li>
                    @if (subItem.elink) {
                      <a class="menu-item menu-subitem" [href]="subItem.elink" target="_blank" rel="noopener">
                        @if ((collapsed && !mobileSidebarOpen) && subItem.icon) {
                          <mat-icon>{{ subItem.icon }}</mat-icon>
                        }
                        @if ((collapsed && !mobileSidebarOpen) && subItem.cssClass) {
                          <span class="custom-icon" [ngClass]="subItem.cssClass"></span>
                        }
                        @if (!collapsed || mobileSidebarOpen) {
                          <span [class.ps-4]="(collapsed && !mobileSidebarOpen) && !!(subItem.icon || subItem.cssClass)">{{ subItem.text }}</span>
                        }
                      </a>
                    } @else {
                      <a
                        class="menu-item menu-subitem"
                        [routerLink]="subItem.link"
                        routerLinkActive="active-link"
                        [routerLinkActiveOptions]="{ exact: true }"
                      >
                        @if ((collapsed && !mobileSidebarOpen) && subItem.icon) {
                          <mat-icon>{{ subItem.icon }}</mat-icon>
                        }
                        @if ((collapsed && !mobileSidebarOpen) && subItem.cssClass) {
                          <span class="custom-icon" [ngClass]="subItem.cssClass"></span>
                        }
                        @if (!collapsed || mobileSidebarOpen) {
                          <span [class.ps-4]="(collapsed && !mobileSidebarOpen) && !!(subItem.icon || subItem.cssClass)">{{ subItem.text }}</span>
                        }
                      </a>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        } @else {
          <li>
            <a
              class="menu-item"
              [routerLink]="item.link"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              @if (item.icon) {
                <mat-icon
                  [matTooltip]="collapsed ? item.text : ''"
                  [matTooltipDisabled]="!collapsed"
                  matTooltipPosition="right"
                  >{{ item.icon }}</mat-icon
                >
              }
              @if (item.cssClass) {
                <span
                  class="custom-icon"
                  [ngClass]="item.cssClass"
                  [matTooltip]="collapsed ? item.text : ''"
                  [matTooltipDisabled]="!collapsed"
                  matTooltipPosition="right"
                ></span>
              }
              @if (!collapsed || mobileSidebarOpen) {
                <span class="ps-4">{{ item.text }}</span>
              }
            </a>
          </li>
        }
      }
    }
  </ul>
  <a
    class="menu-item menu-section-start menu-item--utility"
    [routerLink]="contactUs.link"
    routerLinkActive="active-link"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <mat-icon
      [matTooltip]="collapsed ? contactUs.text : ''"
      [matTooltipDisabled]="!collapsed"
      matTooltipPosition="right"
      >chat</mat-icon
    >
    @if (!collapsed || mobileSidebarOpen) {
      <span class="ps-4">{{ contactUs.text }}</span>
    }
  </a>

  <a
    class="menu-item menu-item--utility"
    [routerLink]="userProfile.link"
    routerLinkActive="active-link"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <mat-icon
      [matTooltip]="collapsed ? userProfile.text : ''"
      [matTooltipDisabled]="!collapsed"
      matTooltipPosition="right"
      >person</mat-icon
    >
    @if (!collapsed || mobileSidebarOpen) {
      <span class="ps-4">{{ userProfile.text }}</span>
    }
  </a>

  <a class="menu-item menu-item--logout menu-item--utility" (click)="logout()">
    <mat-icon
      [matTooltip]="collapsed ? logOut.text : ''"
      [matTooltipDisabled]="!collapsed"
      matTooltipPosition="right"
      >logout</mat-icon
    >
    @if (!collapsed || mobileSidebarOpen) {
      <span class="ps-4">{{ logOut.text }}</span>
    }
  </a>
  <div class="collapse-button">
    <button
      type="button"
      [matTooltip]="collapsed ? 'Åpne meny' : 'Lukk meny'"
      matTooltipPosition="right"
      (click)="toggleCollapse()"
    >
      <mat-icon>
        {{ collapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}
      </mat-icon>
    </button>
  </div>
</nav>
